import { CardSection } from "@design-system/Card/CardSection";
import { Organization } from "@common/types/organization";
import { FC, useState } from "react";
import { Button } from "@design-system/Button/Button";
import { PlainModal, StandardModalHeader } from "@design-system/Modal/Modal";
import styles from "./SettingsPage.module.scss";
import { UpdateNameForm } from "./UpdateNameForm";

interface Props {
    organization: Organization;
}
export const NameSection: FC<Props> = ({ organization }) => {
    const [showEditModal, setShowEditModal] = useState(false);

    return (
        <>
            <CardSection className={styles.section}>
                <main>
                    <header className={styles.sectionHeader}>Firm name</header>
                    <span className={styles.sectionValue}>
                        {organization.name}
                    </span>
                </main>
                <aside>
                    <Button
                        variant="primary"
                        size="md"
                        onClick={() => setShowEditModal(true)}
                    >
                        Edit name
                    </Button>
                </aside>
            </CardSection>

            <PlainModal
                show={showEditModal}
                onHide={() => setShowEditModal(false)}
            >
                <StandardModalHeader>Edit firm name</StandardModalHeader>
                <UpdateNameForm
                    organization={organization}
                    onClose={() => setShowEditModal(false)}
                />
            </PlainModal>
        </>
    );
};
